import React, { useState, useEffect } from 'react'

import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Table,
  Modal,
  Checkbox,
  Space,
} from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { SearchOutlined } from '@ant-design/icons'

import { getCookie } from 'helper/cookie'

import {
  updateCheckList,
  saveCheckList,
  deleteCheckList,
  getResultCheckList,
  optionCheckList,
} from 'api/Project/checklist'
import {
  CarryOutOutlined,
  LeftOutlined,
  BellOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
  FastBackwardFilled,
  PauseCircleTwoTone,
  CloseCircleOutlined,
} from '@ant-design/icons'

import iconEmpty from 'icons/createproject/EmptySprintFlow.svg'

import AddCheckList from './addchecklist/addchecklist'

import lang from 'lang/en'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  // height: auto;
  min-height: 500px;
  margin-top: 16px;
  margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}

const AddTaskKPIFinance = (props) => {
  // console.log(props.id)

  ///lang
  const language = getCookie('lang')
  const word = lang[language]

  const { swithCaseTaskFLowFunction, role, idEditPRJ } = props
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  // const [props.id, setprops.id] = useState()
  const [form2] = Form.useForm()

  const [dataCheckList, setDataCheckList] = useState(initalState.data)
  const [modalVisionadd, setModalVisionadd] = useState()
  const [checklistreq, setChecklistreq] = useState(false)
  const [statebtn, setStatebtn] = useState()
  const [dataEditChecklist, setDataEditChecklist] = useState()
  const [ModalVision, setModalVision] = useState(false)
  const [idEdit, setIdEdit] = useState(false)
  const [checkreq, setCheckReq] = useState(Boolean)
  const [dataOptionChecklist, setDataOptionChecklist] = useState(initalState.data)

  //modal Delete Checklist
  const [visibleModalDelete, setVisibleModalDelete] = useState()
  const [dataDeleteChecklist, setDataDeleteChecklist] = useState()

  const getDataCheckList = async () => {
    await getResultCheckList({
      sprintflow_id: props.id,
      project_id: idEditPRJ,
      token: token,
    })
      .then(async (response) => {
        // console.log(response)
        const { status, data, error } = response

        if (error) {
          setDataCheckList([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataCheckList(data)
          setIsLoading(false)
        } else {
          setDataCheckList([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataCheckList([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getDataOptionCheckList = async () => {
    await optionCheckList({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setDataOptionChecklist([])
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataOptionChecklist(data)
          await setIsLoading(false)
        } else {
          setDataOptionChecklist([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataOptionChecklist([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const onchecklist = (e, rec) => {
    setChecklistreq(e.target.checked)
    let reqcheck

    if (e.target.checked == true) {
      reqcheck = 'Y'
    } else {
      reqcheck = 'N'
    }

    const dataArray = {
      project_id: parseInt(idEditPRJ),
      id: rec.key,
      title: rec.name,
      checklist_type_id: rec.typeID,
      required: reqcheck,
    }
    try {
      updateCheckList({
        params: dataArray,
        token: token,
      }).then((response) => {
        if (response.status === 200) {
          getDataCheckList()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const funcDeleteChecklist = (record) => {
    setVisibleModalDelete(true)
    setDataDeleteChecklist(record)
  }

  const handleOkDeleteChecklist = () => {
    if (role == true) {
    } else {
      const dataArraydeleteChecklist = {
        id: dataDeleteChecklist.key,
        project_id: parseInt(idEditPRJ),
      }
      try {
        deleteCheckList({
          params: dataArraydeleteChecklist,
          token: token,
        }).then((response) => {
          if (response.status === 200) {
            setVisibleModalDelete(false)
            getDataCheckList()
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const EventUseModal = async (rec) => {
    if (role == true) {
    } else {
      setModalVision(true)
      setIdEdit(rec.key)
      if (rec.required == 'Y') {
        rec.required = true
        await setChecklistreq(true)
      } else {
        rec.required = false
        await setChecklistreq(false)
      }

      // console.log(rec.required)

      setCheckReq(rec.required)
      form2.setFieldsValue({
        selectchecklist: rec.typeID,
        namechecklist: rec.name,
        reqchecklist: rec.required,
      })
    }
  }

  const handleOk = (value) => {
    setModalVision(false)
  }
  const handleCancel = () => {
    setModalVision(false)
  }

  const changeChecked = (e) => {

    setCheckReq(!checkreq)
    form2.setFieldsValue({
      reqchecklist: e.target.checked,
    })
  }

  const onFinishEditCheckList = (values) => {


    if (values.reqchecklist == true) {
      values.reqchecklist = 'Y'
    } else {
      values.reqchecklist = 'N'
    }

    const dataArrayEditCheckList = {
      id: idEdit,
      project_id: parseInt(idEditPRJ),
      title: values.namechecklist,
      checklist_type_id: values.selectchecklist,
      required: values.reqchecklist,
    }

    updateCheckList({
      params: dataArrayEditCheckList,
      token: token,
    }).then(async (response) => {
      if (response.status === 200) {
        setModalVision(false)
        getDataCheckList()
      }
    })
  }

  const checklistadd = (rec, btn) => {
    setDataEditChecklist(rec)
    setStatebtn(btn)
    setModalVisionadd(true)
  }

  const dataSource = dataCheckList?.map((item) => ({
    key: item.id,
    name: item.title,
    type: item.checklist_type,
    typeID: item.checklist_type_id,
    required: item.required,
  }))

  const columns = [
    {
      title: word['addtask_information_title_checklist_name'],
      dataIndex: 'name',
      key: 'name',
      // width: 250,
      ellipsis: true,
    },
    {
      title: word['addtask_information_title_checklist_type'],
      dataIndex: 'type',
      key: 'type',
      // width: 200,
      ellipsis: true,
    },
    {
      title: word['addtask_information_title_checklist_req'],
      dataIndex: 'required',
      key: 'required',
      align: 'center',
      // width: 260,
      render: (text, record, index) => {
        var valuecheck = true
        if (text == 'Y') {
          valuecheck = true
        } else {
          valuecheck = false
        }
        if (role == true) {
          return (
            <Space style={{ height: 12 }}>
              <Checkbox
                id={index}
                disabled
                checked={valuecheck}
                onChange={(event) => onchecklist(event, record)}
              ></Checkbox>
            </Space>
          )
        } else {
          return (
            <Space style={{ height: 12 }}>
              <Checkbox
                id={index}
                checked={valuecheck}
                onChange={(event) => onchecklist(event, record)}
              ></Checkbox>
            </Space>
          )
        }
      },
    },
    {
      title: word['addtask_information_title_checklist_action'],
      key: 'action',
      align: 'center',
      render: (text, record, index) => {
        return (
          <div>
            <a id={'edit' + index}>
              <EditOutlined
                style={{ color: '#7C7C84', cursor: role == true ? 'no-drop' : 'unset' }}
                onClick={() => EventUseModal(record)}
              />
            </a>
            <a style={{ marginLeft: 36 }} id={'del' + index}>
              <DeleteOutlined
                style={{ color: '#7C7C84', cursor: role == true ? 'no-drop' : 'unset' }}
                onClick={() => funcDeleteChecklist(record)}
              />
            </a>
          </div>
        )
      },
    },
  ]

  useEffect(() => {
    if (token) {
      getDataCheckList()
      getDataOptionCheckList()
      return () => {}
    }
  }, [token])

  const checkemptychecklist = (data, checkbtn) => {
    if (data.length == 0) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: 450,
            marginTop: 120,
          }}
        >
          <img style={{ width: 84, height: 86 }} src={iconEmpty}></img>
          <h2 style={{ color: '#127EC352', marginTop: 22 }}>
            {word['addtask_information_word_checklist_create']}
          </h2>
          <Button
            id="CreatNew"
            disabled={checkbtn}
            className="BTN_Next"
            onClick={() => checklistadd('-', 'add')}
            style={{ width: 135, marginTop: 32 }}
          >
            <PlusOutlined className="Icon-color" />
            {word['addtask_information_btn_checklist_create']}
          </Button>
        </div>
      )
    } else {
      return (
        <div style={{ marginTop: 36 }}>
          <Row
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h4>{word['addtask_information_title_checklist_checklist']}</h4>

            <Button
              id="AddNew"
              disabled={checkbtn}
              className="BTN_ClassA"
              onClick={() => checklistadd('-', 'add')}
              style={{ width: 135, background: 'blue' }}
            >
              <PlusOutlined className="Icon-color" />
              {word['addtask_information_btn_checklist_addnew']}
            </Button>
          </Row>
          <Table
            id="tableChecklist"
            className="tableassignee"
            // className="Table tablesprinttask"
            style={{ marginTop: 32 }}
            columns={columns}
            dataSource={dataSource}
            pagination={false}
          />
        </div>
      )
    }
  }

  if (role == true) {
    return (
      <Container>
        <Col span={24} className="displayemailchecklist">
          {checkemptychecklist(dataCheckList, true)}
        </Col>

        <AddCheckList
          modalVisionadd={modalVisionadd}
          setModalVisionadd={setModalVisionadd}
          getDataCheckList={getDataCheckList}
          dataEditChecklist={dataEditChecklist}
          statebtn={statebtn}
          id={props.id}
        />
      </Container>
    )
  } else {
    return (
      <Container>
        <Col span={24} className="displayemailchecklist">
          {checkemptychecklist(dataCheckList, false)}
        </Col>

        <AddCheckList
          modalVisionadd={modalVisionadd}
          setModalVisionadd={setModalVisionadd}
          getDataCheckList={getDataCheckList}
          dataEditChecklist={dataEditChecklist}
          statebtn={statebtn}
          id={props.id}
          idEditPRJ={idEditPRJ}
        />

        <Modal
          maskClosable={false}
          className="checklistmodal"
          title={
            <h2 style={{ color: '#127EC3' }}>
              {word['addtask_information_title_modal_checklist']}
            </h2>
          }
          visible={ModalVision}
          onOk={form2.submit}
          onCancel={handleCancel}
          okText="Save"
        >
          <Form form={form2} name="EditChecklist" onFinish={onFinishEditCheckList}>
            <h4>{word['addtask_information_title_modal_checklist_type']}</h4>
            <div style={{ paddingTop: 8 }}>
              <Form.Item
                name="selectchecklist"
                rules={[
                  {
                    required: true,
                    message: word['addtask_information_checklist_Type_Checklist'],
                  },
                ]}
              >
                <Select
                  id="TypeChecklist"
                  placeholder="Type Checklist"
                  style={{ width: 586 }}
                  size="large"
                >
                  {dataOptionChecklist.map((item) => (
                    <Option value={item.id}>{item.name_en}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <h4 style={{ paddingTop: 24 }}>
              {word['addtask_information_title_modal_checklist_name']}
            </h4>
            <div style={{ paddingTop: 8 }}>
              <Form.Item
                name="namechecklist"
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: word['addtask_information_checklist_Name_Checklist'],
                  },
                ]}
              >
                <Input
                  id="namechecklist"
                  className="input"
                  style={{ width: 586 }}
                  placeholder="Name"
                  size="large"
                ></Input>
              </Form.Item>
            </div>

            <div style={{ paddingTop: 24 }}>
              <Form.Item name="reqchecklist" id="reqchecklist">
                <Checkbox id="reqchecklist" onChange={changeChecked} checked={checkreq}>
                  {word['addtask_information_title_modal_checklist_required']}
                </Checkbox>
              </Form.Item>
            </div>
          </Form>
        </Modal>

        <Modal
          maskClosable={false}
          className="DeleteModal"
          visible={visibleModalDelete}
          okText={'Delete'}
          onOk={handleOkDeleteChecklist}
          onCancel={() => setVisibleModalDelete(false)}
        >
          <CloseCircleOutlined className="CloseCircleOutlined" />
          <h2>{word['addtask_information_title_modal_delete_checklist_title']}</h2>

          <h4>{word['addtask_information_title_modal_delete_checklist_des']}</h4>
        </Modal>
      </Container>
    )
  }
}
export default AddTaskKPIFinance
